export const getStorage = (key) => {
  return localStorage.getItem(key);
};

export const setStorage = (key,value) => {
  localStorage.setItem(key,value);
};

export const getJsonStorage = (key) => {
  try{
    return JSON.parse(localStorage.getItem(key));
  }catch (e){
    return null;
  }
};

export const setJsonStorage = (key,value) => {
  localStorage.setItem(key,JSON.stringify(value));
};

export const removeStorage = (key) => {
  localStorage.removeItem(key);
};

export const getShipSearchStorage = () => {
  let shipSearchs = getJsonStorage('rfq_shipSearchs');
  if(!shipSearchs || shipSearchs==null) shipSearchs = [];
  return shipSearchs;
};

export const updateShipSearchStorage = (ship) => {
  let shipSearchs = getJsonStorage('rfq_shipSearchs');
  if(!shipSearchs || shipSearchs==null) shipSearchs = [];
  for(let s in shipSearchs){
    if(shipSearchs[s]['mmsi'] === ship['mmsi']){
      return shipSearchs
    }
  }
  shipSearchs.push(ship);
  setJsonStorage('rfq_shipSearchs',shipSearchs);
  return shipSearchs;
};

export const clearShipSearchStorage = () => {
  setJsonStorage('rfq_shipSearchs',[]);
  return [];
};



// WEBPACK FOOTER //
// ./src/util/storage.js